// for add employee

export const RESET_MANAGE_USER = "reset_manage_user";
export const MANAGE_USER = "manage_user";
export const MANAGE_USER_SUCCESS = "manage_user_success";
export const MANAGE_USER_FAILURE = "manage_user_failure";
